import { NotificationType } from './api';

// Client portal wording is the source of truth (IAM-788). Job type labels mirror
// ai-scribe-backend SERVICE_DISPLAY_NAMES (src/types/service-names.ts), which the
// admin API does not return.
const JOB_TYPE_LABELS: Record<string, string> = {
  'audio-transcription': 'Audio Transcription',
  'text-transform': 'Text Transform',
  'qa-assist': 'Q&A Assist',
  'form-filler': 'Form Filler',
};

// Same fallback as the backend's getServiceDisplayName: title-case the key.
// Old job rows can lack jobType despite the type, so a missing key renders blank.
export const jobTypeLabel = (key: string | undefined): string =>
  !key ? '' : JOB_TYPE_LABELS[key] ?? key.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

// ai-scribe-frontend src/components/layout/NotificationDropdown.tsx
export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  info: 'Update',
  success: 'Success',
  warning: 'Attention',
  feature: 'New Feature',
};
